export default __webpack_public_path__ + "static/media/0intobonus.d653c494.svg";